export default __webpack_public_path__ + "pick-your-capsules.png";